import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, from } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { Theme } from 'src/app/services/http-services/home/home-interfaces';
import { HomeService } from 'src/app/services/http-services/home/home.service';
import { ListInterface, ListExtendedInterface } from 'src/app/services/http-services/lists/lists-http-intterfaces';
import {UserRoles} from '../../../enums/general-enums';

@Component({
  selector: 'app-single-theme',
  templateUrl: './single-theme.component.html',
})
export class SingleThemeComponent implements OnInit {
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  id = 0;
  themes: Array<Theme> = [];
  lists: ListInterface[] | ListExtendedInterface[] | any[] = [];
  pagination!: TlPagination;
  searchTerm = '';
  private searchSubject = new Subject<string>();
  pageNum = 1;
  singleTheme: any;
  paginate = 6;

  constructor(
    private actRoute: ActivatedRoute,
    private homeHttpService: HomeService
  ) { }

  ngOnInit(): void {
    this.getIdAndTheme();
    this.searchSubject.pipe(
      debounceTime(300),
      switchMap((searchTerm: string) => from(this.getSingleThemeLists(searchTerm)))
    ).subscribe(response => {
      this.lists = response.data;
      this.pagination = response.pagination;
    });
  }

  getIdAndTheme(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.id = Number(params.get('id') || '');
      this.lists = [];
      this.getSingleTheme();
    });
  }

  getSingleThemeLists(searchTerm?: string) {
    return from(
      this.homeHttpService.formattedGetSingleThemeLists(this.id, this.pageNum, this.paginate, searchTerm).then((response: any) => {
        this.lists = [...this.lists, ...response.data];
        this.pagination = response.pagination;
        return response;
      })
    );
  }

  getSingleTheme(): void {
    this.homeHttpService.formattedGetSingleTheme(this.id).then((response: any) => {
      this.singleTheme = response.theme;
      this.themes = response.themes;
      this.getSingleThemeLists();
    });
  }

  onSearchChange(event: any): void {
    const keyword = event.target.value;
    this.pageNum = 1;
    this.searchSubject.next(keyword);
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.searchSubject.next('');
  }

  loadMoreLists(): void {
    if ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0)) {
      this.pageNum++;
      this.getSingleThemeLists();
    }
  }

  protected readonly UserRoles = UserRoles;
}
